import { render, staticRenderFns } from "./DiplomaMultiplePickerInput.vue?vue&type=template&id=40a6dfd6&scoped=true&"
import script from "./DiplomaMultiplePickerInput.vue?vue&type=script&lang=js&"
export * from "./DiplomaMultiplePickerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a6dfd6",
  null
  
)

export default component.exports